import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPacman = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 20L29.519 14.5C28.3089 12.4021 26.4404 10.7621 24.2031 9.83463C21.9659 8.90711 19.4851 8.74386 17.1456 9.37019C14.8062 9.99653 12.7388 11.3774 11.2642 13.2987C9.78969 15.2199 8.99042 17.5741 8.99042 19.996C8.99042 22.4178 9.78969 24.772 11.2642 26.6933C12.7388 28.6145 14.8062 29.9954 17.1456 30.6218C19.4851 31.2481 21.9659 31.0848 24.2031 30.1573C26.4404 29.2298 28.3089 27.5899 29.519 25.492L20 20Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 22C31.1046 22 32 21.1046 32 20C32 18.8954 31.1046 18 30 18C28.8954 18 28 18.8954 28 20C28 21.1046 28.8954 22 30 22Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 16C21.3284 16 22 15.3284 22 14.5C22 13.6716 21.3284 13 20.5 13C19.6716 13 19 13.6716 19 14.5C19 15.3284 19.6716 16 20.5 16Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgPacman);
export default ForwardRef;
